import React, { Component } from "react";
import { createStore, applyMiddleware } from "redux";
import createSagaMiddleware from "redux-saga";
import { Provider, connect } from "react-redux";

import reducer from "../../reducers/ambassadors/ambassadors";
import saga from "../../sagas/ambassadors/ambassadors";
import actionCreators from "../../actions/ambassadors/ambassadors";

const sagaMiddleware = createSagaMiddleware();
const store = createStore(reducer, applyMiddleware(sagaMiddleware));
sagaMiddleware.run(saga);

export default class Ambassadors extends Component {
  render() {
    return (
      <div>
        <Provider store={store}>
          <Root ambassadors={this.props.ambassadors} />
        </Provider>
      </div>
    );
  }
}

class TmpRoot extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list: this.props.ambassadors, // 表示用アンバサダー募集リスト
      prefs: [
        <option key={"all"} value="">
          全国
        </option>,
      ], // 都道府県リスト
      prefId: "", // 選択中の都道府県
      services: [
        <option key={"all"} value="">
          全て
        </option>,
      ], // サービスリスト
      serviceId: "", // 選択中のサービス
    };
    this.onChangeField = this.onChangeField.bind(this);
  }

  /**
   * コンポーネントマウント時の処理
   */
  UNSAFE_componentWillMount() {
    // 都道府県リスト取得
    this.props.getPrefList();
    // サービスリスト取得
    this.props.getServiceList();
  }

  /**
   * マウントされたコンポーネントが新しいpropsを受け取る前の処理
   * @param {*} nextProps 新しいprops
   */
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.prefList != this.props.prefList) {
      // 都道府県リスト作成
      let prefs = [
        <option key={"all"} value="">
          全国
        </option>,
      ];
      nextProps.prefList.forEach((pref) => {
        prefs.push(<option value={pref.id.toString()}>{pref.name}</option>);
      });
      this.setState({
        prefs,
      });
    }
    if (nextProps.serviceList != this.props.serviceList) {
      // サービスリスト作成
      let services = [
        <option key={"all"} value="">
          全て
        </option>,
      ];
      nextProps.serviceList.forEach((service) => {
        if (service.id != 1) {
          services.push(
            <option value={service.id.toString()}>{service.genre}</option>
          );
        }
      });
      this.setState({
        services,
      });
    }
    if (nextProps.list != null && nextProps.list != this.state.list) {
      // 表示用アンバサダー募集リスト作成
      this.setState({
        list: nextProps.list,
      });
    }
  }

  /**
   * 入力エリアの値が変更された時の処理
   * @param {*} e
   */
  onChangeField(e) {
    if (e.target.id == "prefId") {
      // 都道府県が変更された場合
      this.props.getManagerRecruitments(e.target.value, this.state.serviceId);
    } else {
      // サービスが変更された場合
      this.props.getManagerRecruitments(this.state.prefId, e.target.value);
    }
    this.setState({
      [e.target.id]: e.target.value,
    });
  }

  render() {
    return (
      <div>
        <div id="content" className="pb-3 bg-white pos-relative pos-zindex-10">
          <div
            className="recruitment-kv"
            style={{
              backgroundImage:
                "url(/communities-assets/img/additional-assets/shake.jpg)",
            }}
          >
            <div className="container center-contents" id="recruitment-list">
              <h2 className="text-white mb-4">
                企業スポンサーからの<br className="sp-only" />プレゼント一覧
              </h2>
              <div data-settings="{&quot;parent&quot;:&quot;#content&quot;,&quot;mind&quot;:&quot;#header&quot;, &quot;top&quot;:10, &quot;breakpoint&quot;:992}">
                {/* <div className="refine-menu">
                  <div className="refine-title"><i className="fas fa-map-marker-alt"></i></div>
                    <select
                      id='prefId'
                      className="refine-content"
                      onChange={this.onChangeField}
                      value={this.state.prefId}
                    >
                      {this.state.prefs}
                    </select>
                    <i className="fas fa-caret-down"></i>&nbsp;
                </div> */}
                {/* <div className="refine-menu mt-3">
                  <div className="refine-title">ジャンル</div>
                  <select
                    id='serviceId'
                    className="refine-content"
                    onChange={this.onChangeField}
                    value={this.state.serviceId}
                  >
                    {this.state.services}
                  </select>
                  <i className="fas fa-caret-down"></i>&nbsp;
                </div> */}
              </div>
              {/* <div className="btn-group btn-group-lg d-flex mt-4 mb-2" role="group" aria-label="...">
                <button type="button" className="btn btn-primary-current text-white rounded-pill w-100 mr-2 btn-text-size sp-width-auto">新着順</button>
                <button type="button" className="btn btn-primary text-white rounded-pill w-100 mr-2 btn-text-size sp-width-auto">締め切り間近</button>
                <button type="button" className="btn btn-primary text-white rounded-pill w-100 btn-text-size sp-width-auto">人気順</button>
              </div> */}
            </div>
          </div>
          <div className="container pt-3">
            <div className="width-full">
              {/* 一覧エリア */}
              {this.state.list.map((data, i) => {
                let recruit_type_text = "新規サークル/既存サークル OK";
                if (data.recruit_type === 1) {
                  recruit_type_text = "新規サークルOK";
                }
                if (data.recruit_type === 2) {
                  recruit_type_text = "既存サークル OK";
                }

                return (
                  <a
                    href={`/ambassadors/${data.hash_id}`}
                    className="card px-3 py-4 mb-3 row-hover pos-relative"
                    key={i}
                  >
                    <div className="row align-items-center ">
                      <div className="col-md-2">
                        <img
                          src={data.logo_image_url}
                          className="img-fluid d-none d-md-block"
                        />
                      </div>
                      <div className="col-md-8">
                        <div className="flex mb-2">
                          <div className="media-body">
                            <div className="flex">
                              <div className="company-icon mr-2">
                                <img
                                  src={data.logo_image_url}
                                  className="img-fluid sp-only d-md-block"
                                />
                              </div>
                              <div>
                                <h4 className="mb-0">{data.title}</h4>
                                <p className="text-muted mb-0 mt-1 text-sm">
                                  <span className="font-weight-bold text-muted">
                                    {data.company.name}
                                  </span>
                                </p>
                              </div>
                            </div>
                            <p className="mt-2">特典：{data.simple_benefits}</p>
                            <p className="text-muted mb-2 text-sm">
                              {data.area_string ? (
                                <span className="d-block d-md-inline">
                                  <i className="fas fa-map-marker-alt" />&nbsp;{
                                    data.area_string
                                  }&nbsp;&nbsp;
                                </span>
                              ) : (
                                ""
                              )}
                              {data.sub_title ? (
                                <span className="d-block d-md-inline">
                                  <i className="fas fa-comment-dots" />&nbsp;{
                                    data.sub_title
                                  }&nbsp;&nbsp;
                                </span>
                              ) : (
                                ""
                              )}
                              {recruit_type_text ? (
                                <span className="d-block d-md-inline">
                                  <i className="far fa-globe" />&nbsp;{
                                    recruit_type_text
                                  }
                                </span>
                              ) : (
                                ""
                              )}
                            </p>
                            {/* <p className="text-muted mb-2 text-sm"><i className="fas fa-user"></i>&nbsp;99人&nbsp;/&nbsp;120人</p> */}
                          </div>
                        </div>
                      </div>
                      <div className="text-md-center details-btn">
                        <span className="btn btn-danger text-uppercase font-weight-bold d-lg-block">
                          詳しく見る
                        </span>
                      </div>
                    </div>
                  </a>
                );
              })}
              <a
                href="/"
                className="text-white btn btn-primary btn-block w-100 btn-text-size sp-width-auto"
              >
                topページに戻る
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  list: state.list,
  prefList: state.prefList,
  serviceList: state.serviceList,
});

const mapDispatchToProps = (dispatch) => {
  return {
    getManagerRecruitments: (prefId, serviceId) => {
      dispatch(
        actionCreators.ambassadors.ambassadors.getManagerRecruitments(
          prefId,
          serviceId
        )
      );
    },
    getPrefList: () => {
      dispatch(actionCreators.ambassadors.ambassadors.getPrefList());
    },
    getServiceList: () => {
      dispatch(actionCreators.ambassadors.ambassadors.getServiceList());
    },
  };
};

const Root = connect(
  mapStateToProps,
  mapDispatchToProps
)(TmpRoot);
